import React from "react"

import HeaderDropdown from "./HeaderDropdown"
import TableHeader from "./TableHeader"
import { Color } from "../../../../constants/V2/color"

type TableHeadersProps = {
  selectedColumns: number[]
  data: string[][]
  columnImages?: string[]
  openDropdownIndex: number | null
  availableColumns: number[]
  tableTheme: "light" | "dark"
  backgroundColor: Color.Black | Color.Charcoal | Color.White | Color.MintGreen
  maxMobileColumns: number
  maxDesktopColumns: number
  onToggleDropdown: (displayIndex: number) => void
  onSelectColumn: (availableColumnIndex: number, displayIndex: number) => void
}

const TableHeaders = ({
  selectedColumns,
  data,
  columnImages,
  openDropdownIndex,
  availableColumns,
  tableTheme,
  backgroundColor,
  maxMobileColumns,
  maxDesktopColumns,
  onToggleDropdown,
  onSelectColumn,
}: TableHeadersProps) => {
  const tableColumns: React.JSX.Element[] = []

  selectedColumns.forEach((columnIndex, displayIndex) => {
    const columnHeading = data[0][columnIndex] || ""
    const isOpen = openDropdownIndex === displayIndex
    const hasAvailableColumns = availableColumns.length > 0

    tableColumns.push(
      <div key={`${columnHeading.replace(" ", "-")}-${columnIndex}`}>
        <TableHeader
          columnHeading={columnHeading}
          columnIndex={columnIndex}
          displayIndex={displayIndex}
          isOpen={isOpen}
          hasAvailableColumns={hasAvailableColumns}
          columnImage={columnImages?.[columnIndex]}
          theme={tableTheme}
          backgroundColor={backgroundColor}
          maxMobileColumns={maxMobileColumns}
          maxDesktopColumns={maxDesktopColumns}
          onToggleDropdown={() => onToggleDropdown(displayIndex)}
        />
        {isOpen && hasAvailableColumns && (
          <HeaderDropdown
            availableColumns={availableColumns}
            data={data}
            columnImages={columnImages}
            displayIndex={displayIndex}
            selectedColumnsLength={selectedColumns.length}
            theme={tableTheme}
            onSelectColumn={(availableColumnIndex) =>
              onSelectColumn(availableColumnIndex, displayIndex)
            }
          />
        )}
      </div>
    )
  })

  return <>{tableColumns}</>
}

export default TableHeaders
